export const flagPicker = (variant: string): string => {
  switch (variant) {
    case 'en':
      return require('svg-country-flags/svg/gb.svg')
    default:
      return require(`svg-country-flags/svg/${variant}.svg`)
  }
}
